// ShareCampaign.jsx — sección "Compartir", mensaje listo para copiar + canales de redes.

import React from 'react'

function ShareIcon({ kind }) {
  const map = {
    whatsapp: <path d="M12 2 C6.5 2 2 6.5 2 12 c0 1.8 .5 3.5 1.4 5 L 2 22 l 5.2 -1.4 c1.5 .8 3.1 1.3 4.8 1.3 c 5.5 0 10 -4.5 10 -10 S 17.5 2 12 2 Z M 8.5 7.5 c .2 -.3 .4 -.4 .6 -.4 c .2 0 .4 0 .5 0 c .2 0 .4 0 .6 .4 c .2 .5 .6 1.5 .7 1.6 c .1 .2 .1 .3 0 .5 c -.1 .2 -.2 .3 -.4 .5 c -.2 .2 -.4 .4 -.5 .6 c -.2 .2 -.3 .3 -.1 .6 c .2 .3 .9 1.4 1.9 2.3 c 1.3 1.1 2.4 1.5 2.7 1.6 c .3 .1 .5 .1 .7 -.1 c .2 -.2 .8 -.9 1 -1.2 c .2 -.3 .4 -.2 .6 -.1 c .3 .1 1.6 .8 1.9 .9 c .3 .2 .5 .2 .6 .4 c .1 .1 .1 .8 -.2 1.5 c -.3 .8 -1.6 1.5 -2.3 1.6 c -.6 .1 -1.3 .1 -2.1 -.1 c -.5 -.2 -1.1 -.4 -1.9 -.7 c -3.3 -1.4 -5.5 -4.8 -5.7 -5 c -.2 -.2 -1.4 -1.8 -1.4 -3.4 c 0 -1.6 .8 -2.4 1.1 -2.7 Z" fill="currentColor" />,
    x: <path d="M 4 4 L 10.5 13 L 4 20 L 6.5 20 L 11.7 14.4 L 15.5 20 L 20 20 L 13.2 10.5 L 19.5 4 L 17 4 L 12 9.3 L 8.5 4 Z" fill="currentColor" />,
    facebook: <path d="M14 22 v -8 h 2.7 l .4 -3.1 H 14 V 8.7 c 0 -.9 .3 -1.5 1.6 -1.5 H 17 V 4.4 c -.3 0 -1.3 -.1 -2.4 -.1 c -2.4 0 -4.1 1.5 -4.1 4.1 v 2.3 H 8 v 3.1 h 2.5 V 22 Z" fill="currentColor" />,
    linkedin: (
      <g fill="currentColor">
        <rect x="3" y="9" width="3.6" height="11" />
        <circle cx="4.8" cy="5.2" r="2" />
        <path d="M 9 9 H 12.5 V 10.6 c .5 -.9 1.6 -1.9 3.5 -1.9 c 3.5 0 4 2.4 4 5.4 V 20 H 16 V 14.7 c 0 -1.3 0 -3 -1.9 -3 c -1.9 0 -2.2 1.5 -2.2 3 V 20 H 9 Z" />
      </g>
    ),
  };
  return <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">{map[kind]}</svg>;
}

function ShareCampaign() {
  const [copied, setCopied] = React.useState(false);
  const url = "https://mecanicaparaquilpue.cl";
  const shareText =
    "En Quilpué los bomberos llegan a todo — menos a los pisos altos. Hoy aporto lo mío para que tengan su nueva escala mecánica. ¿Me acompañas?";

  function copyMsg() {
    const full = `${shareText}\n\nmecanicaparaquilpue.cl\n#MecanicaParaQuilpue`;
    navigator.clipboard?.writeText(full).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  const fullForChannels = `${shareText} mecanicaparaquilpue.cl #MecanicaParaQuilpue`;
  const wa  = `https://wa.me/?text=${encodeURIComponent(fullForChannels)}`;
  const tw  = `https://twitter.com/intent/tweet?text=${encodeURIComponent(`${shareText} #MecanicaParaQuilpue`)}&url=${encodeURIComponent(url)}`;
  const fb  = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  const lin = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;

  return (
    <section id="compartir" style={{ paddingTop: 96, paddingBottom: 96, background: "var(--bg-sunken)", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}>
      <div className="wrap">
        <div className="section-head fade-up">
          <div className="eyebrow"><span className="dot" />Súmate y comparte</div>
          <h2 className="h-section" style={{ marginTop: 14, lineHeight: "calc(0.92em + 12px)" }}>
            <em>Yo apoyo</em> a los bomberos de Quilpué
          </h2>
        </div>
        {/* Canales y mensaje */}
        <div
          className="card-elev share-message-grid"
          style={{ padding: 32, display: "grid", gridTemplateColumns: "minmax(0, 1.1fr) minmax(0, 1fr)", gap: 40, alignItems: "stretch" }}
        >
          <div>
            <div className="kicker" style={{ marginBottom: 10 }}>Mensaje listo para copiar</div>
            <div
              style={{
                background: "var(--bg-sunken)",
                border: "1px solid var(--line)",
                borderRadius: 12,
                padding: 18,
                fontSize: 13.5,
                color: "var(--fg-mute)",
                lineHeight: 1.65,
                marginBottom: 14,
                fontFamily: "var(--sans)",
              }}
            >
              "En Quilpué los bomberos llegan a todo — menos a los pisos altos. Hoy aporto lo mío
              para que tengan su nueva escala mecánica. <strong>¿Me acompañas?</strong>"
              <br />
              <span style={{ color: "var(--gold)", fontWeight: 700 }}>#MecanicaParaQuilpue</span>{" "}
              <span style={{ color: "var(--fg-dim)" }}>· mecanicaparaquilpue.cl</span>
            </div>
            <button onClick={copyMsg} className="btn btn-primary share-copy-btn">
              {copied ? "¡Copiado! ✓" : "Copiar mensaje + enlace"}
            </button>
          </div>

          <div>
            <div className="kicker" style={{ marginBottom: 12 }}>Compartir directo en</div>
            <div style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)", gap: 10, marginBottom: 18 }}>
              <a href={wa} target="_blank" rel="noopener noreferrer" className="share-btn">
                <ShareIcon kind="whatsapp" /><span>WhatsApp</span>
              </a>
              <a href={tw} target="_blank" rel="noopener noreferrer" className="share-btn">
                <ShareIcon kind="x" /><span>X / Twitter</span>
              </a>
              <a href={fb} target="_blank" rel="noopener noreferrer" className="share-btn">
                <ShareIcon kind="facebook" /><span>Facebook</span>
              </a>
              <a href={lin} target="_blank" rel="noopener noreferrer" className="share-btn">
                <ShareIcon kind="linkedin" /><span>LinkedIn</span>
              </a>
            </div>
            <div style={{ fontSize: 12, color: "var(--fg-dim)", lineHeight: 1.55, padding: "10px 12px", background: "var(--accent-soft)", borderRadius: 10 }}>
              <strong style={{ color: "var(--fg)" }}>Tip:</strong> Etiquétanos! <strong style={{ color: "var(--gold)" }}>@bomberosquilpue</strong>{" "}
              y te lo republicamos.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export { ShareCampaign };
